import { Fragment, ReactNode } from 'react';
import { Link } from '@vds/components';

export const parseLinks = (
    translationLinks: string,
    key: string,
    translation: string,
): ReactNode | null => {
    try {
        // parse links from key_links translation
        const links = JSON.parse(translationLinks);

        if (!Array.isArray(links)) {
            return translation;
        }

        const nodes: ReactNode[] = [];
        let lastIndex = 0;

        // {text0}{link0} pattern
        const linkPattern = /{(link\d+)}{(text\d+)}/g;

        for (const match of translation.matchAll(linkPattern)) {
            const [pattern, linkKey, textKey] = match;
            if (match.index === undefined) {
                continue;
            }

            // add text before the link
            if (match.index > lastIndex) {
                nodes.push(translation.substring(lastIndex, match.index));
            }

            const linkObject = links.find((link) => link[linkKey]);

            if (linkObject?.[linkKey] && linkObject[textKey]) {
                nodes.push(
                    <Link target="_blank" size="small" key={linkKey} href={linkObject[linkKey]}>
                        {linkObject[textKey]}
                    </Link>,
                );
            }

            lastIndex = match.index + pattern.length;
        }

        // add remaining text
        if (lastIndex < translation.length) {
            nodes.push(translation.substring(lastIndex));
        }

        return <Fragment key={key}>{...nodes}</Fragment>;
    } catch (error) {
        console.warn(`Failed to parse links for key "${key}_links":`, error);
        return translation;
    }
};
